var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-wrapper"},[_c('nav-bar'),_c('el-main',{staticClass:"main-container"},[_c('div',{staticClass:"content-view"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }